import React from 'react';
import { Image } from '../../../../components/Image';
import { classNames } from '../../../../utils/style';
import { ImageProps } from '../../../../components/Image/types';

export interface ClientWithoutVideoProps {
  image?: ImageProps;
  logo?: ImageProps;
  classnameThumbnail?: string;
  classnameBoxThumbnail?: string;
}

export const ClientWithoutVideo = ({
  image,
  logo,
  classnameThumbnail,
  classnameBoxThumbnail,
}: ClientWithoutVideoProps) => {
  return (
    <div
      className={classNames(
        'relative overflow-hidden group',
        'flex items-center justify-center',
        'h-full w-full',
        classnameBoxThumbnail,
      )}
    >
      {image && (
        <Image
          {...image}
          className={classNames(
            'w-full h-full rounded-18 object-cover',
            classnameThumbnail,
          )}
          sizes={[
            '(max-width: 350px) 325px',
            '(max-width: 1024px) 736px',
            '(max-width: 1240px) 836px',
            '1202px',
          ]}
        />
      )}
      <div
        className={classNames(
          'absolute w-full h-full rounded-18',
          'bg-thumbnail-overlay',
        )}
      />
      {logo && (
        <div
          className={classNames(
            'absolute flex justify-end',
            'h-24 overflow-hidden md:h-48 lg:h-64',
            'bottom-2 right-2 md:bottom-3 md:right-3',
            'lg:bottom-24 lg:right-24 rounded-6',
          )}
        >
          <Image
            {...logo}
            className="w-full h-full rounded-18"
            sizes={['(max-width: 768px) 85px', '202px']}
          />
        </div>
      )}
    </div>
  );
};
